import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material';

const RightSide: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: end;
  gap: 10px;
`;

export default RightSide;